import { Avatar } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import DataTable from "../../components/DataTable/DataTable";
import BlockVisitorForm from "../../components/DialogBoxComponent/BlockVisitorForm";
import CustomStyleStatus from "../../components/statusStyleFormat/statusStyleFormat";
import VisitorProfileCard from "../../components/VisitorActionsComponents/VisitorProfileCard";
import { listInvitations } from "../../slices/Invitations/InvitationsSlice";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import BlockVisitorIcon from "../Invitations/BlockVisitorIcon";
import CheckedOutViewPage from "./CheckedOutViewPage";
import CheckinViewPage from "./CheckinViewPage";

export default function CheckOut(props) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const [blockId, setBlockId] = useState();
  const [registrationId, setRegistrationId] = useState();
  const [openBlockVisitor, setOpenBlockVisitor] = useState(false);
  const { t } = useTranslation();

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 10,
  });

  const defaultPaging = {
    page: 1,
    rowsPerPage: 10,
  };

  const [filter, setFilter] = React.useState({
    firstName: "",
    lastName: "",
    emailId: "",
    mobile: "",
    status: ["CHECKED_OUT"],
    visitorType: "",
    siteId: "",
    scheduledStartDate: "",
    scheduledEndDate: " ",
    fromDate: null,
    toDate: null,
    hostId: "",
    hostEmail: "",
    createdBy: "",
    registrationMode: [],
    isPagable: true,
  });

  const handleBlockVisit = (params) => {
    setOpenBlockVisitor(!openBlockVisitor);
    setBlockId(params.row.visitorId.id);
    setRegistrationId(params.id);
  };

  useEffect(() => {
    const newvariable = { ...props.filterValue, status: "CHECKED_OUT" };
    if (props.filterState) {
      loadData(newvariable, defaultPaging);
    } else {
      loadData(filter, paging);
    }
  }, [props.filterValue ? props.filterValue : filter, paging]);

  useEffect(() => {
    if (props.newState) {
      loadData(filter, paging);
    }
    globalsearch(props.svalue);
  }, [props.svalue]);

  const loadData = (filter, paging) => {
    const payload = {
      filter: filter,
      page: paging.page,
      rowsPerPage: paging.rowsPerPage,
    };

    dispatch(listInvitations(payload))
      .unwrap()
      .then((data) => {
        console.info(data);
        if ((data.code = "CVAI0000" && data.data)) {
          setRows(data.data.visitors);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  const globalsearch = (searchedVal) => {
    if (searchedVal === "Check Out") {
      searchedVal = "CHECKED_OUT";
    }

    const filteredRows = rows.filter((test) => {
      return (
        test.visitorId.firstName
          .toLowerCase()
          .includes(searchedVal.toLowerCase()) ||
        test.purpose.toLowerCase().includes(searchedVal.toLowerCase()) ||
        test.hostName.toLowerCase().includes(searchedVal.toLowerCase()) ||
        test.status.toLowerCase().includes(searchedVal.toLowerCase()) ||
        `${test.visitorId.firstName} ${test.visitorId.lastName}`
          .toLowerCase()
          .includes(searchedVal.toLowerCase())
      );
    });
    setRows(filteredRows);
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { firstName, lastName, profilePhotoURL } = params.row.visitor;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${firstName?.charAt(0) || ""}${lastName?.charAt(0) ||
      ""}`;
    const bgColor = !profilePhotoURL ? getAvatarColor(initials) : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = profilePhotoURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={firstName}
            src={profilePhotoURL || undefined}
          >
            {!profilePhotoURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const totalduration = (params) => {
    let start = moment(params.row.checkIn);
    let end = moment(params.row.checkOut);
    let duration = moment.duration(end.diff(start));
    return (
      Math.floor(duration.asHours()) +
      moment.utc(duration.asMilliseconds()).format(":mm:ss")
    );
  };

  const companySettings = JSON.parse(localStorage.getItem("companySettings"));

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "dd-MM-yyyy":
        return "dd-MM-yyyy HH:mm";
      case "MM-dd-yyyy":
        return "MM-dd-yyyy HH:mm";
      case "yyyy-MM-dd":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };

  const renderCellCheckIn = (date) => (params) => {
    const row = params.row || {};
    const checkIn = row.checkIn || null;
    if (!checkIn) return <span className="table-cell-trucate"></span>;
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(checkIn)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : date === "yyyy-MM-dd HH:mm"
        ? "YYYY-MM-DD HH:mm"
        : ""
    );
    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const columns = React.useMemo(() => [
    {
      field: "visitorId.profile",
      headerName: "",
      sortable: false,
      width: 10,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },
    {
      field: "visitorId.firstName",
      headerName: "Name",
      flex: 1,
      minWidth: 10,
      valueGetter: (params) =>
        params.row.visitorId.firstName + " " + params.row.visitorId.lastName,
    },
    {
      field: "visitorTypeCode",
      headerName: "Purpose",
      flex: 1,
      width: 10,
      valueGetter: (params) => params.row.visitorTypeCode,
    },
    {
      field: "scheduledStartDate",
      headerName: "Invite Date",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        moment(CommonUtil.getLocalDate(params.row.scheduledStartDate)).format(
          "DD-MM-YY kk:mm"
        ),
    },
    {
      field: "checkIn",
      headerName: "Check In",
      flex: 1,
      width: 10,
      valueGetter: (params) =>
        moment(CommonUtil.getLocalDate(params.row.checkIn)).format(
          "DD-MM-YY kk:mm"
        ),
      renderCell: renderCellCheckIn(formatDate(companySettings.dateFormat)),
    },
    {
      field: "checkOut",
      headerName: "Check Out",
      flex: 1,
      width: 10,
      valueGetter: (params) =>
        moment(CommonUtil.getLocalDate(params.row.checkOut)).format(
          "DD-MM-YY kk:mm"
        ),
      renderCell: renderCellCheckIn(formatDate(companySettings.dateFormat)),
    },
    {
      field: "duration",
      headerName: "Total Duration",
      flex: 1,
      width: 10,
      valueGetter: (params) => totalduration(params),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return <CustomStyleStatus row={params.row.status} icon={false} />;
      },
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 205,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<CheckedOutViewPage rowData={params.row} />}
          label="View"
        />,
        <GridActionsCellItem
          icon={<BlockVisitorIcon />}
          label="BlockVisitor"
          onClick={() => handleBlockVisit(params)}
        />,
      ],
    },
  ]);

  return (
    <>
      <DataTable
        columns={columns}
        rows={rows}
        page={page}
        pageCount={totalPages}
        pageSize={rowsPerPage}
        handleChange={(newPage, size) => handleChange(newPage, size)}
      />
      {openBlockVisitor && (
        <BlockVisitorForm
          open={openBlockVisitor}
          handleClose={(data) => {
            setOpenBlockVisitor(data);
            loadData(filter, paging);
          }}
          BlockVisitorId={blockId}
          BlockRegistrationId={registrationId}
        />
      )}
    </>
  );
}
